class ScrollingGallery extends HTMLElement {
  connectedCallback() {
    const speed = parseFloat(this.dataset.speed);
    const direction = this.dataset.direction === 'right' ? 1 : -1;
    const inner = this.querySelector('.scrolling-gallery__wrapper-inner');

    let pos = 0;
    let lastTime = null;
    let paused = false;

    function animate(time) {
      if (!lastTime) lastTime = time;
      const delta = (time - lastTime) / 1000;
      lastTime = time;

      if (!paused) {
        pos += direction * speed * delta;

        if (direction === -1 && pos <= -inner.scrollWidth / 3) {
          pos += inner.scrollWidth / 3;
        } else if (direction === 1 && pos >= 0) {
          pos -= inner.scrollWidth / 3;
        }

        inner.style.transform = `translateX(${pos}px)`;
      }
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);

    this.addEventListener('mouseenter', () => (paused = true));
    this.addEventListener('mouseleave', () => (paused = false));
  }
}

customElements.define('scrolling-gallery', ScrollingGallery);
